var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gift-handover-gate',{attrs:{"page":"gift-application/gift-review-applies","title":"贈品申請"}},[_c('section',[_c('review-list',{attrs:{"query":_vm.query,"mode":"apply"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }